<div class="column-filter-dropdown" (click)="$event.stopPropagation()">
  <div class="filter-header">
    <span class="filter-title">Filter: {{ fieldLabel }}</span>
    <button class="close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <div class="filter-content">
    <!-- Multi-select filter -->
    <ng-container *ngIf="filterType === 'multi-select'">
      <div class="search-box" *ngIf="options.length > 5">
        <input 
          type="text" 
          [(ngModel)]="searchText" 
          (ngModelChange)="onSearchChange()"
          placeholder="Search..."
          class="search-input"
        />
      </div>
      
      <div class="options-list">
        <div 
          class="option-item" 
          *ngFor="let option of filteredOptions"
          (click)="toggleOption(option)"
        >
          <nb-checkbox 
            [checked]="option.selected" 
            (click)="$event.stopPropagation()"
            (checkedChange)="toggleOption(option)"
          ></nb-checkbox>
          <img *ngIf="option.flag" [src]="option.flag" class="option-flag" alt="" />
          <span class="option-label">
            <ng-container *ngIf="option.phoneCode">{{ option.phoneCode }} </ng-container>
            {{ option.label }}
          </span>
        </div>
        
        <div class="no-options" *ngIf="filteredOptions.length === 0">
          No matching options
        </div>
      </div>
      
      <div class="quick-actions" *ngIf="options.length > 0">
        <button class="action-link" (click)="selectAll()">Select All</button>
        <span class="separator">|</span>
        <button class="action-link" (click)="clearAll()">Clear All</button>
      </div>
      
      <div class="invert-toggle" *ngIf="allowsInvert">
        <nb-checkbox [(checked)]="invertFilter">
          Exclude selected (NOT IN)
        </nb-checkbox>
      </div>
    </ng-container>
    
    <!-- Text filter -->
    <ng-container *ngIf="filterType === 'text'">
      <div class="text-filter">
        <input 
          type="text" 
          [(ngModel)]="textFilterValue" 
          placeholder="Enter value to filter..."
          class="text-input"
          (keyup.enter)="applyFilter()"
        />
        <p class="hint">Press Enter or click Apply to filter</p>
        
        <div class="invert-toggle">
          <nb-checkbox [(checked)]="invertFilter">
            Exclude matching (NOT LIKE)
          </nb-checkbox>
        </div>
      </div>
    </ng-container>
    
    <!-- Numeric range filter -->
    <ng-container *ngIf="filterType === 'numeric-range'">
      <div class="numeric-filter">
        <div class="range-inputs">
          <div class="range-field">
            <label>Min</label>
            <input 
              type="number" 
              [(ngModel)]="numericMin" 
              placeholder="Min"
              class="numeric-input"
            />
          </div>
          <span class="range-separator">—</span>
          <div class="range-field">
            <label>Max</label>
            <input 
              type="number" 
              [(ngModel)]="numericMax" 
              placeholder="Max"
              class="numeric-input"
            />
          </div>
        </div>
      </div>
    </ng-container>
    
    <!-- Date range filter -->
    <ng-container *ngIf="filterType === 'date-range'">
      <div class="date-filter">
        <div class="range-inputs">
          <div class="range-field">
            <label>From</label>
            <input 
              type="date" 
              [(ngModel)]="dateFrom" 
              class="date-input"
            />
          </div>
          <span class="range-separator">—</span>
          <div class="range-field">
            <label>To</label>
            <input 
              type="date" 
              [(ngModel)]="dateTo" 
              class="date-input"
            />
          </div>
        </div>
        <p class="hint">Select a date range to filter</p>
      </div>
    </ng-container>
    
    <!-- Has content filter (for upload fields) -->
    <ng-container *ngIf="filterType === 'has-content'">
      <div class="has-content-filter">
        <div class="content-options">
          <div 
            class="content-option" 
            [class.selected]="hasContentValue === true"
            (click)="setHasContent(true)"
          >
            <mat-icon>check_circle</mat-icon>
            <span>Has content</span>
          </div>
          <div 
            class="content-option" 
            [class.selected]="hasContentValue === false"
            (click)="setHasContent(false)"
          >
            <mat-icon>cancel</mat-icon>
            <span>No content</span>
          </div>
        </div>
        <p class="hint">Filter by whether the field has uploaded content</p>
      </div>
    </ng-container>
  </div>
  
  <div class="filter-footer">
    <button class="btn-cancel" (click)="cancel()">Cancel</button>
    <button class="btn-apply" (click)="applyFilter()" [disabled]="!hasActiveFilter && selectedValues.length === 0">
      Apply
    </button>
  </div>
</div>
